module.exports = __webpack_public_path__ + "img/gt.d19399be.svg";